import auth from "./auth/reducer";
import lang from "./lang/reducer";
import homeSearch from "./homeSearch/reducer";
import activeTab from "./activeTab/reducer";
import refresh from "./refresh/reducer";
import profile from "./profile/reducer";
import noticeBoard from "./noticeBoard/reducer";

export default {
  auth,
  lang,
  homeSearch,
  activeTab,
  refresh,
  profile,
  noticeBoard,
};
